import { Component, OnInit, Input } from '@angular/core';
import { Pageable, Page } from 'src/app/model/rest/base';
import {forkJoin, Observable} from 'rxjs';
import {ManagerColV3RestService} from "../../services/rest/v3/manager-col-v3-rest.service";
import * as LessonsV3 from '../../model/v3/lessons';

export class WalletRow {
  date: Date;
  action: string;
  bundleName: string;
  amount: number;
  balance: number;

  constructor(date: Date, action: string, bundleName: string, amount: number) {
    this.date = date;
    this.action = action;
    this.bundleName = bundleName;
    this.amount = amount;
  }
}
@Component({
    selector: 'app-student-transactions',
    templateUrl: './student-transactions.component.html',
    styleUrls: ['./student-transactions.component.css'],
    standalone: false
})
export class StudentTransactionsComponent implements OnInit {

  _lang: string;
  private pageable: Pageable;
  private allListedResults: LessonsV3.LessonCommit[];
  private bundlesById: {[id: number]: LessonsV3.LessonBundle} = {};
  viewRows: WalletRow[];
  availableLessons: number;
  hasNext = false;
  private _studentId: number;
  private _schoolId: number;

  constructor(
    private managerV3Rest: ManagerColV3RestService) {}

  ngOnInit() {
    this.reloadProductCommits();
  }

  @Input()
  public set lang(lang: string) {
    this._lang = lang;
  }

  @Input()
  set studentId(studentId: number) {
    this._studentId = studentId;
  }

  @Input()
  set schoolId(schoolId: number) {
    this._schoolId = schoolId;
  }

  loadCommits(pageable: Pageable): Observable<Page<LessonsV3.LessonCommit>> {
    if (this._schoolId) {
      return this.managerV3Rest.findStudentCommits(
        this._schoolId,
        this._studentId,
        this._lang,
        null,
        null,
        null,
        pageable
      );
    }
  }

  loadStudentLessonBundles(available: boolean | null) {
    if (this._schoolId) {
      return this.managerV3Rest.findStudentLessonBundles(
        this._schoolId,
        this._studentId,
        this._lang,
        available,
        Pageable.of(0, 100, null)
      );
    } else {
    }
  }

  reloadProductCommits(): any {
    if (!this._studentId) return;
    this.clear();

    this.availableLessons = 0;
    forkJoin({
      availableBundlesPage: this.loadStudentLessonBundles(true),
      allBundlesPage: this.loadStudentLessonBundles(null)
    }).subscribe(
      ({availableBundlesPage, allBundlesPage}) => {
        availableBundlesPage.content.forEach(b => this.availableLessons += b.available);
        this.bundlesById = {};
        (allBundlesPage?.content ?? []).forEach(bundle => this.bundlesById[bundle.id] = bundle);
        this.pageable = Pageable.of(0, 10, ['updateDate,desc']);
        this.computeNextPage();
      }
    );
  }

  computeNextPage(): any {
    this.loadCommits(this.pageable)
    .subscribe( page => {
      this.allListedResults = this.allListedResults.concat(page.content);
      this.calculateViewRows();
      this.hasNext = !page.last;
    });
  }

  public moveNext() {
    if (!this.hasNext) {return; }
    this.pageable = this.pageable.next();
    this.computeNextPage();
  }

  calculateViewRows() {
    this.viewRows = [];
    const bundles: {[id: number]: LessonsV3.LessonBundle} = {};

    this.allListedResults.forEach(lessonCommit => {
      const bundle = this.bundlesById[lessonCommit.bundle.id];
      if (bundle) {
        bundles[lessonCommit.bundle.id] = bundle;
      }
    });

    for (const bundle in bundles) {
      if (bundles.hasOwnProperty(bundle)) {
        const element = bundles[bundle];
          this.viewRows.push(new WalletRow(element.date, 'purchased', element.name, element.registeredLesson ));
      }
    }

    this.allListedResults.forEach( commit => {
      const bundleName = this.bundlesById[commit.bundle.id]?.name ?? '';
      if (commit.status === LessonsV3.LessonCommitStatus.PENDING) {
        this.viewRows.push(new WalletRow(commit.createDate, 'reserved', bundleName, -1));
      } else if (commit.status === LessonsV3.LessonCommitStatus.CANCELLED) {
        this.viewRows.push(new WalletRow(commit.createDate, 'reserved', bundleName, -1));
        this.viewRows.push(new WalletRow(commit.updateDate, 'cancelled', bundleName, +1));
      } else {
        this.viewRows.push(new WalletRow(commit.updateDate, 'finished', bundleName, -1));
      }
    });

    this.viewRows = this.viewRows.sort((l, r): number => {
      return new Date(r.date).getTime() - new Date(l.date).getTime();
    });

    let currentlyAvailable = this.availableLessons;
    this.viewRows.forEach( r =>  {
      r.balance = currentlyAvailable;
      currentlyAvailable -= r.amount;
    });
  }

  clear(): any {
    this.pageable = null;
    this.hasNext = false;
    this.allListedResults = [];
    this.bundlesById = {};
  }
}
